import { render, staticRenderFns } from "./ConDirectDeanManagement.vue?vue&type=template&id=a77457ae&"
import script from "./ConDirectDeanManagement.vue?vue&type=script&lang=js&"
export * from "./ConDirectDeanManagement.vue?vue&type=script&lang=js&"
import style0 from "./ConDirectDeanManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports